export default __webpack_public_path__ + "static/media/too-many-works-line-tablet.ce32cbd6.png";